import * as ng from 'angular';
import { UISelectService } from '../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class ConservazioneCaricaDocumentoModelloF23F24Step2Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices',
        '$sce',
        '$filter',
        'UiSelectService'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices,
        private $sce: ng.ISCEService,
        private $filter: ng.IFilterService,
        private UISelectService: UISelectService,
    ) {
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

        if (store.get('conservazioneClasseDocumentale') === null) {
            $state.go('home.conservazione-carica-documento-step1');
            return;
        }


        $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

        $scope.years = [];
        const curr_year = new Date().getFullYear();
        for (let i = curr_year - 1; i <= curr_year; i++) {
            $scope.years.push(i);
        }
        const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {anno: number, scadenza: string}[];
        if (years) {
          for (let year of years) {
            if (new Date(year.scadenza) > new Date()) {
              $scope.years.push(year.anno);
            }
          }
        }

        $scope.PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
        $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');

        $scope.prev = () => {
            $scope.setConservazioneSettings();
            $state.go('home.conservazione-carica-documento-step1', { 'classeDocumentale': $scope.classeDocumentale });
        };

        $rootScope.formsubmitted = false;

        // <editor-fold desc='setConservazioneSettings'>
        $scope.setConservazioneSettings = () => {
            let classeDocumentale = $scope.settings.classeDocumentale.key;

            let userSettings = {
                'key': classeDocumentale,
                'value': $scope.settings
            };

            ArchiSmallServices.setConservazioneSettings(userSettings)
                .then((response: any) => {
                    // ??
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        // <editor-fold desc='getConservazioneSettings'>
        $scope.getConservazioneSettings = () => {
            $rootScope.readyToUse = false;
            $scope.currentClasseDocumentale = $scope.classeDocumentale;
            ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
                .then((response: any) => {
                    if (response !== undefined && response !== '') {
                        $scope.settings = response.value;
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

                    } else {
                        $scope.settings = $scope.getSettingsDefault();
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                        $scope.filesIndex = $scope.settings.files.length;
                        $rootScope.filesUploadedNumber = $scope.filesIndex;
                    }
                    $rootScope.readyToUse = true;
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        if ($scope.classeDocumentale !== '') {
            $scope.getConservazioneSettings();
        }

        /* tslint:enable:no-string-literal */
        $scope.trustAsHtml = (value) => {
            return $sce.trustAsHtml(value);
        };

        $scope.clear = ($event, $select) => {
            UISelectService.clear($event, $select);
        };

        $scope.refreshResults = ($select) => {
            UISelectService.refreshResults($select);
        };

        // <editor-fold desc='openModelloF23F24Modal'>
        $scope.openModelloF23F24Modal = (size) => {

            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerModelloF23F24ModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: () => {
                        return $scope.settings;
                    }
                }
            });
        };
        // </editor-fold>

    }
}

export const ConservazioneCaricaDocumentoModelloF23F24Step2Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-modello-f23-f24-step2.html'),
    controller: ConservazioneCaricaDocumentoModelloF23F24Step2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-f23-f24-step2/conservazione-carica-documento-modello-f23-f24-step2.ts